import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Grid} from "@mui/material";
import CustomButton from "../../../../components/CustomButton";
import {black500, greyishBlue500} from "../../../../assets/jss/main";
import {ReactComponent as AddIcon} from "../../../../assets/img/add-circle.svg";
import {FormattedMessage} from "react-intl";
import WMSCarrierIcon from "../../../../components/WMS/WMSCarrierIcon";

FormToggleSelection.propTypes = {
    data: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
    identity: PropTypes.string.isRequired,
    count: PropTypes.string.isRequired,
    handleSelectValue: PropTypes.func.isRequired,
    getObjectData: PropTypes.func.isRequired,
    isModel: PropTypes.bool.isRequired,
    orderByItemsCount: PropTypes.func,
    icon: PropTypes.string,
    isNotFinal: PropTypes.bool,
    handleAddValue: PropTypes.func
};

const countStyle = {
    padding: "4px 8px",
    backgroundColor: black500,
    color: "white",
    marginLeft: "8px",
    borderRadius: "8px"
}

const idleCountStyle = {
    padding: "4px 8px",
    backgroundColor: greyishBlue500,
    color: "white",
    marginLeft: "8px",
    borderRadius: "8px"
}

const titleStyle = {
    fontWeight: 600,
    fontSize: "12px",
}

function FormToggleSelection({data, title, identity, icon, count, handleSelectValue, isNotFinal, handleAddValue, isModel, orderByItemsCount, getObjectData}) {
    const [formattedData, setFormattedData] = useState([])

    useEffect(() => {
        let tempData = getObjectData(data)

        let sortedData = tempData;

        if (orderByItemsCount) {
            sortedData = orderByItemsCount(tempData, count);
        }

        setFormattedData(sortedData)
    }, [data]);

    return (
        <Grid container direction={"column"} gap={"8px"}>
            <span style={titleStyle}>{title}</span>
            <Grid container gap={"8px"}>
                {formattedData.length > 0 && formattedData.map((d) => {
                    const isSelected = d.selected

                    return (
                        <CustomButton
                            color={isSelected ? "default" : "idle"}
                            onClick={() => handleSelectValue(d)}
                            variant={isSelected ? "outlined" : ""}
                            rounded
                            disabled={!isModel && d.count === 0}
                        >
                            <Grid container direction={"row"} justifyItems={'space-between'} alignItems={'center'}>
                                {icon && d.hasOwnProperty(icon) && '' !== d[icon] && (
                                    <WMSCarrierIcon
                                        iconName={d[icon]}
                                        altName={d[identity]}
                                        width={"16px"}
                                        height={"16px"}
                                        style={{marginRight: '8px'}}
                                    />
                                )}
                                <span style={{margin: 'auto'}}>{d[identity]}</span>
                                <span style={d.selected ? countStyle : idleCountStyle}>{d[count]}</span>
                            </Grid>

                        </CustomButton>
                    )})}
                {isNotFinal && (
                    <CustomButton
                        color={"lightBlue"}
                        onClick={handleAddValue}
                        rounded
                    >
                            <Grid container gap={"8px"} justifyContent={"center"}>
                                <AddIcon />
                                <span style={{height: "fit-content", margin: "auto"}}><FormattedMessage id={"wms.newPickingMission.addProvider.label"}/></span>
                            </Grid>

                    </CustomButton>
                )}
            </Grid>
        </Grid>
    );
}

export default FormToggleSelection;
